import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import Auth from '../helpers/auth';

@Injectable()
export class AppServiceAuthInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = Auth.getToken();
    if (token !== undefined && token !== '') {
      const _req = req.clone(
        {
          headers: req.headers
            .set('Authorization', `bearer ${token}`)
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
        }
      );
      return next.handle(_req);
    }
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/interceptors/app.service.auth.interceptor.ts